/* OutdoorsMarine department mega-menu interaction */
(function () {
  function initMega(mega) {
    var trigger = mega.querySelector('.om-mega__trigger');
    var panel = mega.querySelector('.om-mega__panel');
    var depts = mega.querySelectorAll('.om-mega__dept');
    var panes = mega.querySelectorAll('.om-mega__subpane');
    if (!trigger || !panel) return;

    var openTimer, closeTimer;

    function open() {
      clearTimeout(closeTimer);
      mega.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      mega.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function activate(id) {
      depts.forEach(function (d) { d.classList.toggle('is-active', d.dataset.pane === id); });
      panes.forEach(function (p) { p.classList.toggle('is-active', p.dataset.pane === id); });
    }

    // Toggle via click (works on touch + keyboard)
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      mega.classList.contains('is-open') ? close() : open();
    });

    // Open on hover (desktop, pointer devices)
    if (window.matchMedia('(hover: hover)').matches) {
      mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); openTimer = setTimeout(open, 80); });
      mega.addEventListener('mouseleave', function () { clearTimeout(openTimer); closeTimer = setTimeout(close, 180); });
    }

    // Switch subpane on hover/focus of a department
    depts.forEach(function (d) {
      var id = d.dataset.pane;
      d.addEventListener('mouseenter', function () { activate(id); });
      var link = d.querySelector('a');
      if (link) link.addEventListener('focus', function () { activate(id); });
    });

    // Close on Escape / outside click
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!mega.contains(e.target)) close(); });
  }

  function boot() {
    document.querySelectorAll('.om-mega').forEach(initMega);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
